<script lang="ts"></script>

<svg width="486" height="368" viewBox="0 0 486 368" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle
    class="trace trace-cercle"
    pathLength="1"
    cx="185"
    cy="345"
    r="5"
    stroke="#000091"
    stroke-width="3"
    stroke-miterlimit="10"
    stroke-linecap="round"
  />
  <path
    class="trace trace-arc"
    pathLength="1"
    d="M360 22C360 12.0589 351.941 4 342 4"
    stroke="#000091"
    stroke-width="3"
    stroke-miterlimit="10"
    stroke-linecap="round"
  />
  <path
    stroke="#000091"
    stroke-width="3"
    stroke-miterlimit="10"
    stroke-linecap="round"
    class="trace trace-boucle-1"
    pathLength="1"
    d="M45.1298 318.299C54.8529 334.768 74.1334 346.643 92.7243 342.984C93.7002 342.791 94.6655 342.554 95.6177 342.275"
  />
  <path
    stroke="#000091"
    stroke-width="3"
    stroke-miterlimit="10"
    stroke-linecap="round"
    class="trace trace-boucle-2"
    pathLength="1"
    d="M95.6177 342.275C108.026 338.642 118.22 327.951 121.055 315.246C124.107 301.566 118.362 286.218 107.108 277.774C102.839 274.585 97.7296 272.278 92.4944 272.706C83.991 273.41 77.58 280.922 74.5957 288.918C69.4246 302.752 72.0927 319.347 81.3765 330.923C85.209 335.702 90.1321 339.553 95.6177 342.275Z"
  />
  <path
    stroke="#000091"
    stroke-width="3"
    stroke-miterlimit="10"
    stroke-linecap="round"
    class="trace trace-boucle-3"
    pathLength="1"
    d="M95.6177 342.275C103.421 346.147 112.362 347.736 120.921 346.464C134.952 344.379 147.565 334.662 153.264 321.655"
  />
  <path
    stroke="#000091"
    stroke-width="3"
    stroke-miterlimit="10"
    stroke-linecap="round"
    class="trace trace-boucle-4"
    pathLength="1"
    d="M153.264 321.655C153.486 321.149 153.697 320.637 153.898 320.121C155.259 316.686 156.163 312.946 155.463 309.329C154.763 305.713 152.157 302.218 148.515 301.461C143.66 300.399 138.736 305.023 138.692 310.008C138.647 314.993 142.596 319.489 147.304 321.007C149.228 321.626 151.249 321.815 153.264 321.655Z"
  />
  <path
    stroke="#000091"
    stroke-width="3"
    stroke-miterlimit="10"
    stroke-linecap="round"
    class="trace trace-boucle-5"
    pathLength="1"
    d="M153.264 321.655C156.181 321.424 159.087 320.462 161.671 319.023C166.039 316.588 169.55 313.06 172.877 309.32C181.479 299.709 188.86 289.036 194.84 277.542"
  />
</svg>
